module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-bold-straight-UHOZTY66.eot?1023d9a6529a9e7732a63cdc8e01b628";